import { render, staticRenderFns } from "./dataCard.vue?vue&type=template&id=6d4ede70&scoped=true&"
import script from "./dataCard.vue?vue&type=script&lang=js&"
export * from "./dataCard.vue?vue&type=script&lang=js&"
import style0 from "./dataCard.vue?vue&type=style&index=0&id=6d4ede70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ede70",
  null
  
)

export default component.exports